import { EditorState } from "@tiptap/pm/state";

import { GUIDED_HIGHLIGHTING_ACTIVITY_PANEL } from "@/view/GuidedHighlightingContainer/utils/utils";
import {
  fixEndOffsetForTextHighlighting,
  fixStartOffsetForTextHighlighting,
  getNodePositionByXpath,
} from "@/view/TiptapArticleBody/components/TextSelectionMenu/AnnotationsTextSelectionMenu/utils";
import { getDynamicData } from "@/view/TiptapArticleBody/extensions/DataProvider";
import { IAnnotationDecoration } from "@/view/TiptapArticleBody/extensions/TextHighlighting";

export const getAnnotations = (state: EditorState): IAnnotationDecoration[] => {
  const { levelId, annotations, activityPanel } = getDynamicData(state);

  if (activityPanel === GUIDED_HIGHLIGHTING_ACTIVITY_PANEL) return [];

  const annotationDecorations: IAnnotationDecoration[] = [];

  const relevantAnnotations = annotations.filter(
    ({ article }) => article.content_id === levelId,
  );

  for (const annotation of relevantAnnotations) {
    try {
      const { start, startoffset, end, endoffset } = annotation;

      const startPosition = getNodePositionByXpath(state, start);
      const endPosition = getNodePositionByXpath(state, end, true);

      // TODO: deal with this more gracefully
      if (startPosition === undefined || endPosition === undefined) continue;

      let startIndex = startPosition + startoffset + 1;
      let endIndex = endPosition + endoffset + 1;

      endIndex = fixEndOffsetForTextHighlighting(
        state,
        startIndex,
        endPosition,
        endPosition + endoffset + 1, // original endIndex
      );
      startIndex = fixStartOffsetForTextHighlighting(
        state,
        startIndex,
        startPosition,
      );

      const style = {
        penName: annotation.pen_name,
      };

      annotationDecorations.push({ startIndex, endIndex, style });
    } catch (error) {
      console.error("Error processing annotation:", annotation, error);
      continue;
    }
  }

  return annotationDecorations;
};

export const getAnnotationOnClick = (
  focusAnnotationCard: ((annotationId: string) => void) | null,
) => {
  return (state: EditorState) => {
    const { activityPanel } = getDynamicData(state);
    const isGuidedHighlightingModeActive =
      activityPanel === GUIDED_HIGHLIGHTING_ACTIVITY_PANEL;

    if (!focusAnnotationCard || isGuidedHighlightingModeActive) return;

    const { selection } = state;
    const { from, to } = selection;
    const { annotations } = getDynamicData(state);

    const annotation = annotations.find(
      ({ start, startoffset, end, endoffset }) => {
        const startPosition = getNodePositionByXpath(state, start);
        const endPosition = getNodePositionByXpath(state, end);

        let isIndexWithinRange = false;
        if (startPosition !== undefined && endPosition !== undefined) {
          const startIndex = startPosition + startoffset;
          const endIndex = endPosition + endoffset;

          isIndexWithinRange =
            (from >= startIndex && from <= endIndex) ||
            (to >= startIndex && to <= endIndex);
        }

        return isIndexWithinRange;
      },
    );

    if (annotation) focusAnnotationCard(annotation.id);
  };
};
